import React from "react";
import MFAMapWrapper from "./MFAMapWrapper";

function MFAMapViewer() {
	return (
		<div
			style={{
				width: "100%",
				height: "100%",
				backgroundColor: "#a2a8a4",
				borderRadius: "0 0 8px 8px",
				overflow: "hidden",
				position: "relative",
				display: "flex",
				flexDirection: "column",
			}}
		>
			<MFAMapWrapper />
		</div>
	);
}

export default MFAMapViewer;
